import { addDoc, collection, serverTimestamp } from 'firebase/firestore';
import { appId, db } from '@/lib/firebase';

export type CkdStatus = 'patient' | 'survivor' | 'caregiver';

export interface AmbassadorApplicationInput {
  fullName: string;
  email: string;
  phone?: string | null;
  country: string;
  ckdStatus: CkdStatus;
  socialFacebook?: string | null;
  socialTiktok?: string | null;
  socialYoutube?: string | null;
  socialInstagram?: string | null;
  storySnippet: string;
  languages?: string | null;
  consentAcknowledged: boolean;
  source: string;
}

export async function submitAmbassadorApplication(
  input: AmbassadorApplicationInput
): Promise<void> {
  const collRef = collection(db, 'artifacts', appId, 'public', 'data', 'ambassadorApplications');
  await addDoc(collRef, {
    fullName: input.fullName.trim(),
    email: input.email.trim().toLowerCase(),
    phone: input.phone?.trim() || null,
    country: input.country.trim(),
    ckdStatus: input.ckdStatus,
    socialFacebook: input.socialFacebook?.trim() || null,
    socialTiktok: input.socialTiktok?.trim() || null,
    socialYoutube: input.socialYoutube?.trim() || null,
    socialInstagram: input.socialInstagram?.trim() || null,
    storySnippet: input.storySnippet.trim(),
    languages: input.languages?.trim() || null,
    consentAcknowledged: input.consentAcknowledged,
    source: input.source,
    submittedAt: serverTimestamp(),
  });
}
